import {useHistory} from "react-router-dom";
import {useEffect} from "react";

function ScrollToTop() {
    const history = useHistory();
    useEffect(() => {
        return history.listen((action) => {
            if (action !== 'POP') {
                window.scrollTo(0, 0);
            }
        });
    }, []);
    return null;
}

export default ScrollToTop;
